<template>
  <div class="cooperation">
    <div class="home_carousel">
      <div class="carousel_img">
        <div class="carousel_con">
          <h2>与每一种力量</h2>
          <h2>共筑智慧、便捷、美好生活</h2>
          <div class="englishTitle">
            <div>AND EVERY POWER</div>
            <div>
              BUILD A SMART, CONVENIENT AND BETTER LIFT TOGET PROCUREMENT
              SOLUTIONS
            </div>
          </div>
          <div class="line"></div>
          <button  @click="applyShow" class="btn">立即申请试用</button>
        </div>
        <div></div>
      </div>
    </div>
    <div class="content">
      <div class="title"><h1>合作案例</h1></div>
      <div v-for="item in caseData" :key="item.id">
        <div class="caseBox" v-if="item.type === '0'">
          <div class="caseImg">
            <img :src="item.img" alt="" />
          </div>
          <div class="caseContent">
            <div class="name">{{ item.title }}</div>
            <div class="line"></div>
            <div class="message">
              {{ item.content }}
              <div class="front">
                <img src="../assets/yinhaoLeft.png" alt="" />
              </div>
              <div class="back">
                <img src="../assets/yinhaoRight.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="caseBox" v-if="item.type === '1'">
          <div class="caseContent">
            <div class="name end">{{ item.title }}</div>
            <div class="line"></div>
            <div class="message">
              {{ item.content }}
              <div class="front">
                <img src="../assets/yinhaoLeft.png" alt="" />
              </div>
              <div class="back">
                <img src="../assets/yinhaoRight.png" alt="" />
              </div>
            </div>
          </div>
          <div class="caseImg">
            <img :src="item.img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <ApplyDialog :show.sync="show"></ApplyDialog>
  </div>
</template>

<script>
import SlideBar from "../components/sidebar.vue";
import ApplyDialog from "../components/applyDialog.vue";
export default {
  components: { SlideBar, ApplyDialog },
  data() {
    return {
      show: false,
      caseData: [
        {
          img: require("../assets/cooperation1.png"),
          title: "K12",
          content:
            "家长线上充值，学生刷卡、刷脸就餐。用餐数据可视化， 结合菜品销售数据制定菜谱，数据全流程监控，便于食 堂高效管理和决策分析。",
          type: "0",
        },
        {
          img: require("../assets/cooperation2.png"),
          title: "高校",
          content:
            "线上充值，刷卡、刷脸、扫码就餐，实时获取消费信息 掌握消费情况。为食堂管理者提供食堂运营的数据支撑。",
          type: "1",
        },
        {
          img: require("../assets/cooperation3.png"),
          title: "企业、政府",
          content:
            "多种就餐模式，包括在线预订、餐柜取餐等。 支持餐补结算，为食堂管理者提供食堂运营的数据支撑。",
          type: "0",
        },
        {
          img: require("../assets/cooperation4.png"),
          title: "园区",
          content:
            "聚合支付避免漏单，食堂合理备餐减少浪费，智能对账 及时结算，员工就餐数据可视化，个性化服务提升满意度。",
          type: "1",
        },
        {
          img: require("../assets/cooperation5.png"),
          title: "其他",
          content: "团餐、养老院、医院、其他快餐、轻餐等... ...",
          type: "0",
        },
      ],
    };
  },
  methods: {
    applyShow() {
      this.show = true;
      // 禁止滚动
      this.noScroll();
    },
  },
};
</script>

<style lang="scss" scoped>
.cooperation {
  width: 100%;
  height: 100%;
  position: relative;
  .home_carousel {
    width: 100%;
    .carousel_img {
      background: url("../assets/cooperation6.png") no-repeat center center;
      background-size: cover;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 7.5rem 2.5rem 7.5rem;
      height: 40.3125rem;

      .carousel_con {
        display: block;
        width: 48%;
        animation: fadenum 2s;
        & > h2 {
          font-size: 2.125rem;
          font-weight: bold;
          color: #ffffff;
        }
        .englishTitle {
          font-size: 0.75rem;
          font-weight: 400;
          color: #ffffff;
          margin-top: 3.875rem;
        }

        .line {
          width: 1.875rem;
          height: 0.25rem;
          background: #0e6eb8;
          margin: 2.5rem 0;
        }
        & > button {
          font-size: 1.25rem;
          font-weight: bold;
          background: none;
          color: #2777b9;
          padding: 1.1875rem 1.9375rem;
          border-radius: 0.25rem;
          border: 2px solid #2777b9;
          cursor: pointer;
        }
        & > button:hover {
          background: #0e6eb8;
          color: #ffffff;
          transition: .2s;
        }
      }
      @keyframes fadenum {
        0% {
          transform: translateX(-150px);
        }
      }
    }
  }
  .content {
    background-color: #ffffff;
    .title h1 {
      text-align: center;
      font-size: 2.5rem;
      font-weight: bold;
      padding: 6.25rem 0 3.75rem 0;
    }
    .caseBox {
      display: flex;
      justify-content: space-around;
      // margin: 0 9.375rem;
      margin: 1rem 7.5rem 2.5rem 7.5rem;
      border: 0.125rem solid #eeeeee;
      box-shadow: 0px 0px 2.5rem 0px rgba(1, 37, 64, 0.08);
      border-radius: 0.625rem;
      padding: 3.125rem 2.5rem;
      margin-bottom: 3.125rem;
      overflow: hidden;
      .caseImg {
        transition: all 1s linear 0.1s;
        img {
          width: 25rem;
          height: 13.75rem;
        }
      }
      .caseImg:hover {
        transform: scale(1.3);
      }
      .caseContent {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        width: 25rem;
        .name {
          font-size: 1.75rem;
          font-weight: bold;
          color: #333333;
          margin-bottom: 1.875rem;
          &.end {
            display: flex;
            justify-content: flex-end;
            font-size: 1.75rem;
            font-weight: bold;
            color: #333333;
            margin-bottom: 1.875rem;
          }
        }
      }
      .line {
        height: 0.0625rem;
        background: #eeeeee;
        margin-bottom: 3.75rem;
      }
      .message {
        position: relative;
        font-size: 1rem;
        font-weight: 400;
        color: #666666;
        .front {
          position: absolute;
          top: -2.8125rem;
          left: 0px;
          & > img {
            width: 3.875rem;
            height: 2.375rem;
          }
        }
        .back {
          position: absolute;
          right: 0;
          & > img {
            width: 3.875rem;
            height: 2.375rem;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
  html,
  body {
    width: 100vw;
    overflow: auto;
  }
  .home_carousel {
    margin-top: 70px !important;
  }
  .caseBox {
    align-items: center !important;
  }
  .back,
  .front {
    img {
      width: 3.125rem;
      height: 3.125rem;
    }
  }
}
</style>